import { mergeMap, pluck } from 'rxjs/operators'
import actions from '../../../actions/slides'
import { DocsType } from '../../../actions/docs/docsTypes'
import { ofType } from 'redux-observable'

const setSlidesInitialState$ = actions$ => actions$.pipe(
  ofType(DocsType.SET_SLIDES_DOCUMENT),
  pluck('payload'),
  mergeMap(({ data }) =>
    Object.entries(data)
      .reduce((dispatch = [], [k, v]) => {

        switch (k) {

          case 'slideDecks':
            dispatch.push(actions.setSlideDecks(v))
            break
          default:
            break

        }

        return dispatch

      }, [])

  )
)

export default setSlidesInitialState$
